<template>
  <v-layout row class="pa-2">
    <v-spacer />
    <skill-icon v-for="(skill, index) in skills"
      :key="index"
      :skill="skill"
    />
  </v-layout>
</template>

<script>
import SkillIcon from '@/components/projects/SkillIcon.vue';

export default {
  props: ['skills'],
  components: {
    'skill-icon': SkillIcon,
  },
};
</script>
